var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "settings-content" },
    [
      _c(
        "div",
        {
          staticClass: "settings-menu settings-menu-title options",
          on: {
            click: function($event) {
              _vm.changePasswordDialog = true
            }
          }
        },
        [_vm._v("\n    " + _vm._s(_vm.$t("ChangePassword")) + "\n  ")]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "settings-menu settings-menu-title options disabled",
          on: { click: _vm.changeTwoFactorAuthentication }
        },
        [
          _vm._v(
            "\n    " +
              _vm._s(
                _vm.twoFactorAuthentication
                  ? _vm.$t("Deactivate2FA")
                  : _vm.$t("Activate2FA")
              ) +
              "\n  "
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "settings-menu settings-menu-title options",
          staticStyle: { display: "flex", "align-items": "center", gap: "8px" }
        },
        [
          _c("span", [_vm._v(_vm._s(_vm.$t("Metric")))]),
          _vm._v(" "),
          _c("v-switch", {
            on: {
              change: function($event) {
                _vm.confirmPageRefreshDialog = true
              }
            },
            model: {
              value: _vm.isImperial,
              callback: function($$v) {
                _vm.isImperial = $$v
              },
              expression: "isImperial"
            }
          }),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.$t("Imperial")))])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "settings-menu select-language" },
        [
          _c("div", { staticClass: "settings-menu-title" }, [
            _vm._v(_vm._s(_vm.$t("Language")))
          ]),
          _vm._v(" "),
          _c("treeselect", {
            staticClass: "settings-menu-select",
            attrs: {
              options: _vm.options,
              clearable: false,
              disableFuzzyMatching: ""
            },
            model: {
              value: _vm.selectedLanguage,
              callback: function($$v) {
                _vm.selectedLanguage = $$v
              },
              expression: "selectedLanguage"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("change-password-dialog", {
        attrs: { open: _vm.changePasswordDialog },
        on: {
          close: function($event) {
            _vm.changePasswordDialog = false
          }
        }
      }),
      _vm._v(" "),
      _c("activate-two-authentication-dialog", {
        attrs: { open: _vm.openTwoFactorAuthenticationDialog },
        on: {
          close: function($event) {
            _vm.openTwoFactorAuthenticationDialog = false
          },
          activateAuthenticate: function($event) {
            _vm.twoFactorAuthentication = true
          }
        }
      }),
      _vm._v(" "),
      _c("app-dialog-box", {
        attrs: {
          open: _vm.confirmPageRefreshDialog,
          title: _vm.$t("RefreshPage"),
          content: _vm.$t("ConfirmRefreshPage"),
          "main-action-label": _vm.$t("No"),
          "secondary-action-label": _vm.$t("Yes")
        },
        on: {
          mainAction: _vm.cancelMeasuringSystemchange,
          secondaryAction: _vm.changeMeasureSystem
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-af407f0a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-af407f0a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/User/Navbar/UserWindow/SettingsMenu.vue
// module id = null
// module chunks = 